// Vehicle form config

export const vehiclesFields = [
    {
        key: 'defendant-vehicle-information',
        name: 'Defendant Vehicle Information',
        fields: [
            {
                name: 'defendant_vehicle_reg',
                label: 'Defendant Vehicle Reg',
                type: 'text',
                validation: {},
            },
            {
                name: 'defendant_vehicle_make',
                label: 'Defendant Vehicle Make',
                type: 'text',
                validation: {},
            },
            {
                name: 'defendant_vehicle_model',
                label: 'Defendant Vehicle Model',
                type: 'text',
                validation: {},
            },
            {
                name: 'defendant_vehicle_engine_size',
                label: 'Defendant Vehicle Engine Size',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'engineSize'}],
            },
            {
                name: 'defendant_vehicle_mileage',
                label: 'Defendant Vehicle Mileage',
                type: 'integer',
                custom_placeholder: 'Not recorded',
                validation: {},
            },
            {
                name: 'defendant_vehicle_gta_rate_id',
                label: 'Defendant Vehicle GTA Group',
                type: 'gta_rate',
                validation: {},
            },
        ],
    },
    {
        key: 'claimant-vehicle-information',
        name: 'Claimant Vehicle Information',
        fields: [
            {
                name: 'claimant_vehicle_reg',
                label: 'Claimant Vehicle Reg',
                type: 'text',
                validation: [{name: 'required'}]
            },
            {
                name: 'claimant_vehicle_make',
                label: 'Claimant Vehicle Make',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_vehicle_model',
                label: 'Claimant Vehicle Model',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_vehicle_engine_size',
                label: 'Claimant Vehicle Engine Size',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'engineSize'}],
            },
            {
                name: 'claimant_vehicle_mileage',
                label: 'Claimant Vehicle Mileage',
                type: 'integer',
                custom_placeholder: 'Not recorded',
                validation: {},
            },
            {
                name: 'claimant_vehicle_gta_rate_id',
                label: 'Claimant Vehicle GTA Group',
                type: 'gta_rate'
            },
            {
                name: 'claimant_vehicle_abi_gta_rate',
                label: 'Claimant Vehicle ABI GTA Rate',
                type: 'float',
                validation: {},
            },
            {
                name: 'claimant_vin_nb',
                label: 'Claimant VIN Number',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_vehicle_mot_present',
                label: 'Claimant Vehicle MOT present?',
                type: 'boolean',
                validation: [{name: 'required'}],
            },
            {
                name: 'claimant_vehicle_last_mot_date',
                label: 'Claimant Vehicle - Last MOT Date',
                type: 'date',
                validation: [{name: 'required'}]
            },
            {
                name: 'claimant_vehicle_taxed',
                label: 'Claimant Vehicle Taxed?',
                type: 'boolean',
                validation: [{name: 'required'}],
            },
            {
                name: 'claimant_vehicle_tax_due_date',
                label: 'Claimant Vehicle Tax Due Date',
                type: 'date',
                changesAnotherFieldValue: {
                    targetField: 'claimant_vehicle_taxed',
                    compareField: {
                        category: 'claim_info',
                        field: 'accident_date'
                    },
                    compare: {
                        type: 'dateAfter',
                        trueValue: 1,
                        falseValue: 0
                    }
                },
                validation: [{name: 'required'}]
            },
            {
                name: 'claimant_vehicle_valid_insurance',
                label: 'Claimant Vehicle Valid Insurance',
                type: 'boolean',
                validation: [{name: 'required'}],
                disabled: true
            },
            {
                name: 'claimant_vehicle_insurance_expiry',
                label: 'Claimant Vehicle Insurance Renewal/Expiry',
                type: 'date',
                changesAnotherFieldValue: {
                    targetField: 'claimant_vehicle_valid_insurance',
                    compareField: {
                        category: 'claim_info',
                        field: 'accident_date'
                    },
                    compare: {
                        type: 'dateBefore',
                        trueValue: 0,
                        falseValue: 1
                    }
                },
                validation: [{name: 'required'}]
            },
            {
                name: 'claimant_vehicle_plate_change_flag',
                label: 'Claimant Vehicle - Plate Change Flag',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'claimant_vehicle_stolen_marker_flag',
                label: 'Claimant Vehicle - Stolen Marker Flag',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'claimant_vehicle_finance_marker_flag',
                label: 'Claimant Vehicle - Finance Marker Flag',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'claimant_vehicle_previous_total_loss_flag',
                label: 'Claimant Vehicle - Previous Total Loss Flag',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'claimant_vehicle_last_registered_keeper_flag',
                label: 'Claimant Vehicle - Last Registered Keeper Flag',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'claimant_vehicle_last_registered_keeper_date',
                label: 'Claimant Vehicle - Last Registered Keeper Date',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_vehicle_pav',
                label: 'Claimant Vehicle - PAV',
                type: 'float',
                validation: {},
            },
        ],
    },
    {
        key: 'hire-vehicle-information',
        name: 'Hire Vehicle Information',
        fields: [
            {
                name: 'hire_vehicle_gta_rate_id_1',
                label: 'Hire Vehicle GTA Group (1)',
                type: 'gta_rate',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_reg_1',
                label: 'Hire Vehicle Reg (1)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_make_1',
                label: 'Hire Vehicle Make (1)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_model_1',
                label: 'Hire Vehicle Model (1)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_engine_size_1',
                label: 'Hire Vehicle Engine Size (1)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: {},
                modalValidation: [{name: 'engineSize'}],
            },
            {
                name: 'hire_vehicle_mileage_1',
                label: 'Hire Vehicle Mileage (1)',
                type: 'integer',
                custom_placeholder: 'Not recorded',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_mot_present_1',
                label: 'Hire Vehicle MOT Status (1)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: [{name: 'required'}],
            },
            {
                name: 'hire_vehicle_last_mot_date_1',
                label: 'Hire Vehicle - Last MOT Date (1)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: [{name: 'required'}]
            },
            {
                name: 'hire_vehicle_taxed_1',
                label: 'Hire Vehicle Tax Status (1)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: [{name: 'required'}],
                disabled: true
            },
            {
                name: 'hire_vehicle_tax_due_date_1',
                label: 'Hire Vehicle Tax Due Date (1)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: [{name: 'required'}]
            },
            {
                name: 'hire_vehicle_insurance_valid_1',
                label: 'Hire vehicle insurance valid? (1)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: [{name: 'required'}],
                disabled: true
            },
            {
                name: 'hire_vehicle_insurance_expiry_1',
                label: 'Hire vehicle insurance renewal/expiry date (1)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_plate_change_flag_1',
                label: 'Hire Vehicle - Plate Change Flag (1)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_stolen_marker_flag_1',
                label: 'Hire Vehicle - Stolen Marker Flag (1)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_finance_marker_flag_1',
                label: 'Hire Vehicle - Finance Marker Flag (1)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_previous_total_loss_flag_1',
                label: 'Hire Vehicle - Previous Total Loss Flag (1)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_has_extras_1',
                label: 'Does the Hire Vehicle Have Any Extras? (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 0,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_gta_rate_id_2',
                label: 'Hire Vehicle GTA Group (2)',
                type: 'gta_rate',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5,
                    firstInGroup: true,
                    addButtonLabel: "Add hire vehicle"
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_reg_2',
                label: 'Hire Vehicle Reg (2)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_make_2',
                label: 'Hire Vehicle Make (2)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_model_2',
                label: 'Hire Vehicle Model (2)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_engine_size_2',
                label: 'Hire Vehicle Engine Size (2)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
                modalValidation: [{name: 'engineSize'}],
            },
            {
                name: 'hire_vehicle_mileage_2',
                label: 'Hire Vehicle Mileage (2)',
                type: 'integer',
                custom_placeholder: 'Not recorded',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_mot_present_2',
                label: 'Hire Vehicle MOT Status (2)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_last_mot_date_2',
                label: 'Hire Vehicle - Last MOT Date (2)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_taxed_2',
                label: 'Hire Vehicle Tax Status (2)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
                disabled: true
            },
            {
                name: 'hire_vehicle_tax_due_date_2',
                label: 'Hire Vehicle Tax Due Date (2)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                changesAnotherFieldValue: {
                    targetField: 'hire_vehicle_taxed_2',
                    compareField: {
                        category: 'claim_info',
                        field: 'accident_date'
                    },
                    compare: {
                        type: 'dateAfter',
                        trueValue: 0,
                        falseValue: 1
                    }
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_insurance_valid_2',
                label: 'Hire vehicle insurance valid? (2)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
                disabled: true
            },
            {
                name: 'hire_vehicle_insurance_expiry_2',
                label: 'Hire vehicle insurance renewal/expiry date (2)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                changesAnotherFieldValue: {
                    targetField: 'hire_vehicle_insurance_valid_2',
                    compareField: {
                        category: 'claim_info',
                        field: 'accident_date'
                    },
                    compare: {
                        type: 'dateBefore',
                        trueValue: 1,
                        falseValue: 0
                    }
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_plate_change_flag_2',
                label: 'Hire Vehicle - Plate Change Flag (2)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_stolen_marker_flag_2',
                label: 'Hire Vehicle - Stolen Marker Flag (2)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_finance_marker_flag_2',
                label: 'Hire Vehicle - Finance Marker Flag (2)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_previous_total_loss_flag_2',
                label: 'Hire Vehicle - Previous Total Loss Flag (2)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_has_extras_2',
                label: 'Does the Hire Vehicle Have Any Extras? (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 1,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_gta_rate_id_3',
                label: 'Hire Vehicle GTA Group (3)',
                type: 'gta_rate',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5,
                    firstInGroup: true,
                    addButtonLabel: "Add hire vehicle"
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_reg_3',
                label: 'Hire Vehicle Reg (3)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_make_3',
                label: 'Hire Vehicle Make (3)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_model_3',
                label: 'Hire Vehicle Model (3)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_engine_size_3',
                label: 'Hire Vehicle Engine Size (3)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
                modalValidation: [{name: 'engineSize'}],
            },
            {
                name: 'hire_vehicle_mileage_3',
                label: 'Hire Vehicle Mileage (3)',
                type: 'integer',
                custom_placeholder: 'Not recorded',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_mot_present_3',
                label: 'Hire Vehicle MOT Status (3)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_last_mot_date_3',
                label: 'Hire Vehicle - Last MOT Date (3)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_taxed_3',
                label: 'Hire Vehicle Tax Status (3)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
                disabled: true
            },
            {
                name: 'hire_vehicle_tax_due_date_3',
                label: 'Hire Vehicle Tax Due Date (3)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                changesAnotherFieldValue: {
                    targetField: 'hire_vehicle_taxed_3',
                    compareField: {
                        category: 'claim_info',
                        field: 'accident_date'
                    },
                    compare: {
                        type: 'dateAfter',
                        trueValue: 0,
                        falseValue: 1
                    }
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_insurance_valid_3',
                label: 'Hire vehicle insurance valid? (3)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
                disabled: true
            },
            {
                name: 'hire_vehicle_insurance_expiry_3',
                label: 'Hire vehicle insurance renewal/expiry date (3)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                changesAnotherFieldValue: {
                    targetField: 'hire_vehicle_insurance_valid_3',
                    compareField: {
                        category: 'claim_info',
                        field: 'accident_date'
                    },
                    compare: {
                        type: 'dateBefore',
                        trueValue: 1,
                        falseValue: 0
                    }
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_plate_change_flag_3',
                label: 'Hire Vehicle - Plate Change Flag (3)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_stolen_marker_flag_3',
                label: 'Hire Vehicle - Stolen Marker Flag (3)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_finance_marker_flag_3',
                label: 'Hire Vehicle - Finance Marker Flag (3)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_previous_total_loss_flag_3',
                label: 'Hire Vehicle - Previous Total Loss Flag (3)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_has_extras_3',
                label: 'Does the Hire Vehicle Have Any Extras? (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 2,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_gta_rate_id_4',
                label: 'Hire Vehicle GTA Group (4)',
                type: 'gta_rate',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5,
                    firstInGroup: true,
                    addButtonLabel: "Add hire vehicle"
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_reg_4',
                label: 'Hire Vehicle Reg (4)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_make_4',
                label: 'Hire Vehicle Make (4)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_model_4',
                label: 'Hire Vehicle Model (4)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_engine_size_4',
                label: 'Hire Vehicle Engine Size (4)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
                modalValidation: [{name: 'engineSize'}],
            },
            {
                name: 'hire_vehicle_mileage_4',
                label: 'Hire Vehicle Mileage (4)',
                type: 'integer',
                custom_placeholder: 'Not recorded',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_mot_present_4',
                label: 'Hire Vehicle MOT Status (4)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_last_mot_date_4',
                label: 'Hire Vehicle - Last MOT Date (4)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_taxed_4',
                label: 'Hire Vehicle Tax Status (4)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
                disabled: true
            },
            {
                name: 'hire_vehicle_tax_due_date_4',
                label: 'Hire Vehicle Tax Due Date (4)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                changesAnotherFieldValue: {
                    targetField: 'hire_vehicle_taxed_4',
                    compareField: {
                        category: 'claim_info',
                        field: 'accident_date'
                    },
                    compare: {
                        type: 'dateAfter',
                        trueValue: 0,
                        falseValue: 1
                    }
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_insurance_valid_4',
                label: 'Hire vehicle insurance valid? (4)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
                disabled: true
            },
            {
                name: 'hire_vehicle_insurance_expiry_4',
                label: 'Hire vehicle insurance renewal/expiry date (4)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                changesAnotherFieldValue: {
                    targetField: 'hire_vehicle_insurance_valid_4',
                    compareField: {
                        category: 'claim_info',
                        field: 'accident_date'
                    },
                    compare: {
                        type: 'dateBefore',
                        trueValue: 1,
                        falseValue: 0
                    }
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_plate_change_flag_4',
                label: 'Hire Vehicle - Plate Change Flag (4)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_stolen_marker_flag_4',
                label: 'Hire Vehicle - Stolen Marker Flag (4)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_finance_marker_flag_4',
                label: 'Hire Vehicle - Finance Marker Flag (4)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_previous_total_loss_flag_4',
                label: 'Hire Vehicle - Previous Total Loss Flag (4)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_has_extras_4',
                label: 'Does the Hire Vehicle Have Any Extras? (4)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 3,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_gta_rate_id_5',
                label: 'Hire Vehicle GTA Group (5)',
                type: 'gta_rate',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5,
                    firstInGroup: true,
                    addButtonLabel: "Add hire vehicle"
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_reg_5',
                label: 'Hire Vehicle Reg (5)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_make_5',
                label: 'Hire Vehicle Make (5)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_model_5',
                label: 'Hire Vehicle Model (5)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_engine_size_5',
                label: 'Hire Vehicle Engine Size (5)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
                modalValidation: [{name: 'engineSize'}],
            },
            {
                name: 'hire_vehicle_mileage_5',
                label: 'Hire Vehicle Mileage (5)',
                type: 'integer',
                custom_placeholder: 'Not recorded',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_mot_present_5',
                label: 'Hire Vehicle MOT Status (5)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_last_mot_date_5',
                label: 'Hire Vehicle - Last MOT Date (5)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_taxed_5',
                label: 'Hire Vehicle Tax Status (5)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
                disabled: true
            },
            {
                name: 'hire_vehicle_tax_due_date_5',
                label: 'Hire Vehicle Tax Due Date (5)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                changesAnotherFieldValue: {
                    targetField: 'hire_vehicle_taxed_5',
                    compareField: {
                        category: 'claim_info',
                        field: 'accident_date'
                    },
                    compare: {
                        type: 'dateAfter',
                        trueValue: 0,
                        falseValue: 1
                    }
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_insurance_valid_5',
                label: 'Hire vehicle insurance valid? (5)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
                disabled: true
            },
            {
                name: 'hire_vehicle_insurance_expiry_5',
                label: 'Hire vehicle insurance renewal/expiry date (5)',
                type: 'date',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                changesAnotherFieldValue: {
                    targetField: 'hire_vehicle_insurance_valid_5',
                    compareField: {
                        category: 'claim_info',
                        field: 'accident_date'
                    },
                    compare: {
                        type: 'dateBefore',
                        trueValue: 1,
                        falseValue: 0
                    }
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_plate_change_flag_5',
                label: 'Hire Vehicle - Plate Change Flag (5)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_stolen_marker_flag_5',
                label: 'Hire Vehicle - Stolen Marker Flag (5)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_finance_marker_flag_5',
                label: 'Hire Vehicle - Finance Marker Flag (5)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_previous_total_loss_flag_5',
                label: 'Hire Vehicle - Previous Total Loss Flag (5)',
                type: 'boolean',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'hire_vehicle_has_extras_5',
                label: 'Does the Hire Vehicle Have Any Extras? (5)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_vehicles',
                    index: 4,
                    total: 5
                },
                validation: {},
            },
            {
                name: 'claimant_vehicle_last_api_info_run',
                label: 'Claimant Vehicle Last Api Information Run',
                type: 'date',
                validation: {},
            },
            {
                name: 'auto',
                label: 'Auto',
                type: 'float',
                validation: {},
            },
            {
                name: 'auto_as_standard',
                label: 'Auto as standard?',
                type: 'boolean',
                validation: [{name: 'required'}]
            },
            {
                name: 'estate',
                label: 'Estate',
                type: 'text',
                validation: {},
            },
            {
                name: 'estate_as_standard',
                label: 'Estate as standard?',
                type: 'boolean',
                validation: [{name: 'required'}]
            },
            {
                name: 'dual_control',
                label: 'Dual Control',
                type: 'text',
                validation: {},
            },
            {
                name: 'top_box',
                label: 'Top Box',
                type: 'text',
                validation: {},
            },
            {
                name: 'pannier',
                label: 'Pannier',
                type: 'text',
                validation: {},
            },
            {
                name: 'non_standard_driver_charge',
                label: 'Non Standard Driver Charge (ABI GTA)',
                type: 'float',
                validation: {},
            },
            {
                name: 'collision_damage_waiver',
                label: 'Collision Damage Waiver',
                type: 'float',
                validation: {},
            },
            {
                name: 'delivery_and_collection',
                label: 'Delivery and Collection?',
                type: 'float',
                validation: {},
            },
            {
                name: 'additional_driver_charges',
                label: 'Additional Driver Charges',
                type: 'float',
                validation: {},
            },
            {
                name: 'other_daily_rate',
                label: 'Other daily rate',
                type: 'float',
                validation: {},
            },
            {
                name: 'other_one_off_value',
                label: 'Value',
                type: 'float',
                validation: {},
            },
        ],
    },
    {
        key: 'claimant-bhr-information',
        name: 'Claimant Vehicle BHR Information',
        fields: [
            {
                name: 'basic_hire_rate_obtained_1',
                label: 'Claimant vehicle BHR obtained (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_deposit_amount_1',
                label: 'Basic Hire Rate Deposit Amount (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_cdw_amount_1',
                label: 'Basic Hire Rate CDW Amount (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_additional_driver_daily_rate_1',
                label: 'Basic Hire Rate Additional Driver Daily Rate (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_young_driver_daily_rate_1',
                label: 'Basic Hire Rate Young Driver Daily Rate (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'total_basic_hire_rate_amount_1',
                label: 'Total Basic Hire Rate Amount (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_total_rental_cost_1',
                label: 'Total Rental Cost (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_total_excess_waiver_cost_1',
                label: 'Total Excess Waiver Cost (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_delivery_and_collection_1',
                label: 'Delivery and Collection (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_provider_1',
                label: 'Basic Hire Rate Provider (1)',
                type: 'text',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_location_1',
                label: 'Basic Hire Rate Location (1)',
                type: 'text',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_distance_to_claimant_1',
                label: 'Basic Hire Rate Distance to Claimant (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_obtained_2',
                label: 'Claimant vehicle BHR obtained (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 1,
                    total: 3,
                    firstInGroup: true,
                    addButtonLabel: "Add hire rate information"
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_deposit_amount_2',
                label: 'Basic Hire Rate Deposit Amount (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_cdw_amount_2',
                label: 'Basic Hire Rate CDW Amount (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_additional_driver_daily_rate_2',
                label: 'Basic Hire Rate Additional Driver Daily Rate (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_young_driver_daily_rate_2',
                label: 'Basic Hire Rate Young Driver Daily Rate (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'total_basic_hire_rate_amount_2',
                label: 'Total Basic Hire Rate Amount (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_total_rental_cost_2',
                label: 'Total Rental Cost (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_total_excess_waiver_cost_2',
                label: 'Total Excess Waiver Cost (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_delivery_and_collection_2',
                label: 'Delivery and Collection (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_provider_2',
                label: 'Basic Hire Rate Provider (2)',
                type: 'text',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_location_2',
                label: 'Basic Hire Rate Location (2)',
                type: 'text',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_distance_to_claimant_2',
                label: 'Basic Hire Rate Distance to Claimant (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_obtained_3',
                label: 'Claimant vehicle BHR obtained (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 2,
                    total: 3,
                    firstInGroup: true,
                    addButtonLabel: "Add hire rate information"
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_deposit_amount_3',
                label: 'Basic Hire Rate Deposit Amount (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_cdw_amount_3',
                label: 'Basic Hire Rate CDW Amount (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_additional_driver_daily_rate_3',
                label: 'Basic Hire Rate Additional Driver Daily Rate (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_young_driver_daily_rate_3',
                label: 'Basic Hire Rate Young Driver Daily Rate (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'total_basic_hire_rate_amount_3',
                label: 'Total Basic Hire Rate Amount (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_total_rental_cost_3',
                label: 'Total Rental Cost (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_total_excess_waiver_cost_3',
                label: 'Total Excess Waiver Cost (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_delivery_and_collection_3',
                label: 'Delivery and Collection (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_provider_3',
                label: 'Basic Hire Rate Provider (3)',
                type: 'text',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_location_3',
                label: 'Basic Hire Rate Location (3)',
                type: 'text',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_distance_to_claimant_3',
                label: 'Basic Hire Rate Distance to Claimant (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_claimant_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
        ],
    },
    {
        key: 'hire-bhr-information',
        name: 'Hire Vehicle BHR Information',
        fields: [
            {
                name: 'basic_hire_rate_hire_obtained_1',
                label: 'Hire vehicle BHR obtained (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_deposit_amount_1',
                label: 'Basic Hire Rate Deposit Amount (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_cdw_amount_1',
                label: 'Basic Hire Rate CDW Amount (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_additional_driver_daily_rate_1',
                label: 'Basic Hire Rate Additional Driver Daily Rate (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_young_driver_daily_rate_1',
                label: 'Basic Hire Rate Young Driver Daily Rate (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'total_basic_hire_hire_rate_amount_1',
                label: 'Total Basic Hire Rate Amount (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_total_rental_cost_1',
                label: 'Total Rental Cost (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_total_excess_waiver_cost_1',
                label: 'Total Excess Waiver Cost (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_delivery_and_collection_1',
                label: 'Delivery and Collection (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_provider_1',
                label: 'Basic Hire Rate Provider (1)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_location_1',
                label: 'Basic Hire Rate Location (1)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_distance_to_claimant_1',
                label: 'Basic Hire Rate Distance to Claimant (1)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_obtained_2',
                label: 'Hire vehicle BHR obtained (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 1,
                    total: 3,
                    firstInGroup: true,
                    addButtonLabel: "Add hire rate information"
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_deposit_amount_2',
                label: 'Basic Hire Rate Deposit Amount (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_cdw_amount_2',
                label: 'Basic Hire Rate CDW Amount (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_additional_driver_daily_rate_2',
                label: 'Basic Hire Rate Additional Driver Daily Rate (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_young_driver_daily_rate_2',
                label: 'Basic Hire Rate Young Driver Daily Rate (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'total_basic_hire_hire_rate_amount_2',
                label: 'Total Basic Hire Rate Amount (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_total_rental_cost_2',
                label: 'Total Rental Cost (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_total_excess_waiver_cost_2',
                label: 'Total Excess Waiver Cost (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_delivery_and_collection_2',
                label: 'Delivery and Collection (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_provider_2',
                label: 'Basic Hire Rate Provider (2)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_location_2',
                label: 'Basic Hire Rate Location (2)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_distance_to_claimant_2',
                label: 'Basic Hire Rate Distance to Claimant (2)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 1,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_obtained_3',
                label: 'Hire vehicle BHR obtained (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 2,
                    total: 3,
                    firstInGroup: true,
                    addButtonLabel: "Add hire rate information"
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_deposit_amount_3',
                label: 'Basic Hire Rate Deposit Amount (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_cdw_amount_3',
                label: 'Basic Hire Rate CDW Amount (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_additional_driver_daily_rate_3',
                label: 'Basic Hire Rate Additional Driver Daily Rate (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_young_driver_daily_rate_3',
                label: 'Basic Hire Rate Young Driver Daily Rate (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'total_basic_hire_hire_rate_amount_3',
                label: 'Total Basic Hire Rate Amount (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_total_rental_cost_3',
                label: 'Total Rental Cost (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_total_excess_waiver_cost_3',
                label: 'Total Excess Waiver Cost (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_delivery_and_collection_3',
                label: 'Delivery and Collection (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 0,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_provider_3',
                label: 'Basic Hire Rate Provider (3)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_location_3',
                label: 'Basic Hire Rate Location (3)',
                type: 'text',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
            {
                name: 'basic_hire_rate_hire_distance_to_claimant_3',
                label: 'Basic Hire Rate Distance to Claimant (3)',
                type: 'float',
                grouppedFields: {
                    key: 'v_hire_rate',
                    index: 2,
                    total: 3,
                },
                validation: {},
            },
        ],
    },
    {
        key: 'intervention-information',
        name: 'Intervention Information',
        fields: [
            {
                name: 'has_intervention_been_offered',
                label: 'Has Intervention Been Offered?',
                type: 'boolean',
                dependencySource: true,
                dependencyMatchValue: 1,
                validation: [{name: 'required'}]
            },
            {
                name: 'cho_informed_intervention_offer',
                label: 'CHO informed of Intervention Offer',
                type: 'boolean',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                validation: {},
            },
            {
                name: 'date_cho_informed_intervention_offer',
                label: 'Date CHO Informed of Intervention Offer (GTA)',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                validation: [{name: 'required'}]
            },
            {
                name: 'date_cho_made_off_services',
                label: 'Date CHO made off of services(GTA)',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                validation: {},
            },
            {
                name: 'first_to_customer',
                label: 'First To Customer (GTA)',
                type: 'boolean',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                validation: {},
            },
            {
                name: 'method_of_intervention',
                label: 'Method of Intervention',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                validation: {},
            },
            {
                name: 'copley_letter_sent',
                label: 'Copley Letter Sent',
                type: 'boolean',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                validation: [{name: 'required'}]
            },
            {
                name: 'date_of_copley_letter_1',
                label: 'Date of Copley Letter (1)',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 0,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'method_of_sending_1',
                label: 'Method of Sending (1)',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 0,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'date_copley_letter_received_1',
                label: 'Date Copley Letter Received (1)',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 0,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'date_copley_letter_read_1',
                label: 'Date Copley Letter Read (1)',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 0,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'ip_address_recorded_1',
                label: 'IP Address Recorded (1)',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 0,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'was_copley_letter_valid_1',
                label: 'Was Copley Letter Valid? (1)',
                type: 'boolean',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 0,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'date_of_copley_letter_2',
                label: 'Date of Copley Letter (2)',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 1,
                    total: 3,
                    firstInGroup: true,
                    addButtonLabel: "Add intervention information"
                },
                validation: {},
            },
            {
                name: 'method_of_sending_2',
                label: 'Method of Sending (2)',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 1,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'date_copley_letter_received_2',
                label: 'Date Copley Letter Received (2)',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 1,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'date_copley_letter_read_2',
                label: 'Date Copley Letter Read (2)',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 1,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'ip_address_recorded_2',
                label: 'IP Address Recorded (2)',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 1,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'was_copley_letter_valid_2',
                label: 'Was Copley Letter Valid? (2)',
                type: 'boolean',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 1,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'date_of_copley_letter_3',
                label: 'Date of Copley Letter (3)',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 2,
                    total: 3,
                    firstInGroup: true,
                    addButtonLabel: "Add intervention information"
                },
                validation: {},
            },
            {
                name: 'method_of_sending_3',
                label: 'Method of Sending (3)',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 2,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'date_copley_letter_received_3',
                label: 'Date Copley Letter Received (3)',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 2,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'date_copley_letter_read_3',
                label: 'Date Copley Letter Read (3)',
                type: 'date',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 2,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'ip_address_recorded_3',
                label: 'IP Address Recorded (3)',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 2,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'was_copley_letter_valid_3',
                label: 'Was Copley Letter Valid? (3)',
                type: 'boolean',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                grouppedFields: {
                    key: 'intervention_info',
                    index: 2,
                    total: 3
                },
                validation: {},
            },
            {
                name: 'applicable_intervention_rate',
                label: 'Applicable Intervention Rate',
                type: 'float',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                validation: {},
            },
            {
                name: 'assumed_hire_vehicle',
                label: 'Assumed Hire Vehicle = CC?',
                type: 'boolean',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                validation: [{name: 'required'}]
            },
            {
                name: 'claimant_vehicle_is_motorcycle',
                label: 'Is Claimant Vehicle Motorcycle',
                type: 'boolean',
                dependency: {
                    type: 'visibility',
                    sourceField: 'has_intervention_been_offered',
                    matchValue: 1,
                },
                validation: [{name: 'required'}]
            },
        ],
    },
];
